import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const ContentWrapStyled = styled(Box)(() => ({
  display: 'grid',
  placeItems: 'center',
  margin: '30px 0px'
}));
